import React, { type SFC } from "react";
import { FormattedMessage } from "react-intl";
import RaangeLabel from "src/shared/components/RaangeLabel";

export const LogoutLabel: SFC<{}> = () => {
  return (
    <RaangeLabel fa="sign-out-alt">
      <FormattedMessage id="authentication.logout" />
    </RaangeLabel>
  );
};
